<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.cadastro.usuario"
        ref="RkmDataTable"
    >
        <template v-slot:cell(actions)="{item}">
            <template v-if="!item.usuario_bloqueado">
                <rkm-button
                    v-if="authorize('cadastro-usuario-update')"
                    @click="handleBlock(item)"
                    color="warning"
                    small
                    title="Bloquear acesso"
                    v-rkm-tooltip.hover
                >
                    <rkm-icon icon="lock" />
                </rkm-button>
            </template>

            <template v-else>
                <rkm-button
                    v-if="authorize('cadastro-usuario-update')"
                    @click="handleUnlock(item)"
                    color="success"
                    small
                    title="Desbloquear acesso"
                    v-rkm-tooltip.hover
                >
                    <rkm-icon icon="unlock" />
                </rkm-button>
            </template>

            <rkm-button
                v-if="authorize('cadastro-usuario-update')"
                :to="{name: 'cadastro-usuario-edit', params: {id: item.usuario_id}}"
                color="primary"
                small
                title="Editar"
                v-rkm-tooltip.hover
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                v-if="authorize('cadastro-usuario-destroy')"
                @click="handleDestroy(item)"
                color="danger"
                small
                title="Excluir"
                v-rkm-tooltip.hover
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import {authorization, error, notification} from '@/mixins'

export default {
    computed: {
        fields() {
            return [
                {key: 'usuario_nome', label: 'Nome', name: 'cadastro_usuario.nome', searchable: true, sortable: true},
                {key: 'usuario_data_nascimento', label: 'Data de nascimento', name: 'cadastro_usuario.data_nascimento', searchable: true, sortable: true},
                {key: 'usuario_cpf_numero', label: 'CPF', name: 'cadastro_usuario.cpf_numero', searchable: true, sortable: true},
                {class: 'col-min text-center', key: 'actions', label: 'Ações'},
            ]
        },
    },
    inject: ['repositories'],
    methods: {
        handleBlock(item) {
            const block = () => this.repositories.cadastro.usuario.block(item.usuario_id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showWarningConfirmation('Confirmação', `Deseja realmente bloquear o usuário ${item.usuario_nome}?`, block, null, this.handleError)
        },
        handleUnlock(item) {
            const unlock = () => this.repositories.cadastro.usuario.unlock(item.usuario_id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showWarningConfirmation('Confirmação', `Deseja realmente desbloquear o usuário ${item.usuario_nome}?`, unlock, null, this.handleError)
        },
        handleDestroy(item) {
            const destroy = () => this.repositories.cadastro.usuario.destroy(item.usuario_id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showDangerConfirmation('Confirmação', `Deseja realmente excluir o usuário ${item.usuario_nome}?`, destroy, null, this.handleError)
        },
    },
    mixins: [authorization, error, notification],
}
</script>